// nt-fx-pag-b.js: comparacao com o mercado no estilo novo (sections/nt-fx-comparar.liquid).
// converte o preco das colunas importadas pelo dolar do dia. so o cambio e ao vivo: preco de origem e imposto
// sao ajustes do dono. falhou a consulta, fica o valor escrito a mao que ja esta na tela.
(function () {
  'use strict';

  var HORA = 60 * 60 * 1000;
  var CHAVE = 'nt-usd-brl';

  function guardada() {
    try {
      var bruto = sessionStorage.getItem(CHAVE);
      if (!bruto) return null;
      var d = JSON.parse(bruto);
      return Date.now() - d.em < HORA ? d.taxa : null;
    } catch (e) { return null; }
  }

  function guardar(taxa) {
    try { sessionStorage.setItem(CHAVE, JSON.stringify({ taxa: taxa, em: Date.now() })); } catch (e) {}
  }

  var pedido = null;
  function cotacao() {
    var salva = guardada();
    if (salva) return Promise.resolve(salva);
    if (!pedido) {
      pedido = fetch('https://economia.awesomeapi.com.br/json/last/USD-BRL')
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (j) {
          var taxa = parseFloat(j.USDBRL && j.USDBRL.bid);
          if (!(taxa > 0)) throw new Error('sem cotacao');
          guardar(taxa);
          return taxa;
        });
    }
    return pedido;
  }

  function converter(secao) {
    var celulas = secao.querySelectorAll('[data-nt-usd]');
    if (!celulas.length) return Promise.resolve();
    return cotacao().then(function (taxa) {
      var imposto = 1 + (Number(secao.dataset.ntImposto) || 0) / 100;
      var real = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
      celulas.forEach(function (celula) {
        var usd = Number(celula.dataset.ntUsd);
        var alvo = celula.querySelector('[data-nt-preco]');
        if (!(usd > 0) || !alvo) return;
        // dezena de cima: e preco de referencia, centavo num numero que muda todo dia finge precisao
        var brl = Math.ceil(usd * imposto * taxa / 10) * 10;
        alvo.textContent = (secao.dataset.ntPrefixo || '') + real.format(brl);
      });
      var nota = secao.querySelector('[data-nt-cotacao]');
      if (nota) {
        nota.textContent = ' ' + (secao.dataset.ntNotaCotacao || 'Dólar de hoje:') + ' ' +
          new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(taxa) + '.';
        nota.hidden = false;
      }
    });
  }

  function ligar() {
    document.querySelectorAll('[data-fx-comparar][data-nt-imposto]').forEach(function (secao) {
      if (secao.dataset.fxConvertido) return;
      secao.dataset.fxConvertido = '1';
      converter(secao).catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar, { once: true });
  } else {
    ligar();
  }
  // editor de temas: a secao recarregada volta sem a conversao
  document.addEventListener('shopify:section:load', ligar);
})();
